import mutations from "../mutations/paymentMutaion";
import getters from "../getters/paymentGetter";
import actions from "../actions/payment/paymentAction";

/**
 * [GX] Payment
 */
export default {
  state: {
    purchasedTime: {
      //购买过的次数
      iap: 0,
      paypal: 0,
      card: 0,
      coin: 0
    },
    first_enter_timestamp: 0, //首次启动app的时间戳
    purchasedOffer: [], //购买过的offer数据
    failedOffer: [], //购买失败的订单数据列表
    vipPackage: [], //购买过的vippackageoffer数据
    appLaunchTime: 0, //app的启动过的次数
    delivedViewAppearTime: 0, // 货物到达后，推荐的 view 显示的次数
    paymentSwitchThreshold: null, //阈值开关，用来灰度控制支付方式
    lastPurchasedSpecialOffer: null, // 最新购买成功的 sp offer
    orderStatus:null,//支付落地页l完成状态
    isRecommendOrder:null,//是否是支付页推荐的订单
  },
  actions,
  mutations,
  getters
};
